import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6c4f3ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my_uploader" }
const _hoisted_2 = {
  key: 0,
  class: "myImg"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 1024 1024",
  width: "20px",
  height: "20px",
  xmlns: "http://www.w3.org/2000/svg",
  "data-v-78e17ca8": ""
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896zm0 393.664L407.936 353.6a38.4 38.4 0 1 0-54.336 54.336L457.664 512 353.6 616.064a38.4 38.4 0 1 0 54.336 54.336L512 566.336 616.064 670.4a38.4 38.4 0 1 0 54.336-54.336L566.336 512 670.4 407.936a38.4 38.4 0 1 0-54.336-54.336L512 457.664z"
  })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "my_tip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_el_upload, {
        class: "avatar-uploader",
        action: _ctx.UploadUrl,
        "show-file-list": false,
        "on-success": _ctx.handleAvatarSuccess,
        "before-upload": _ctx.beforeAvatarUpload,
        accept: ".jpg,.jpeg,.bmp,.png,.GIF,.JPG,.PNG"
      }, {
        default: _withCtx(() => [
          (_ctx.imageUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("img", {
                  src: _ctx.imageUrl,
                  class: "avatar"
                }, null, 8, _hoisted_3),
                _createElementVNode("div", {
                  class: "delectRouter",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.delectImg && _ctx.delectImg(...args)), ["stop"]))
                }, _hoisted_5)
              ]))
            : (_openBlock(), _createBlock(_component_el_icon, {
                key: 1,
                class: "avatar-uploader-icon"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Plus)
                ]),
                _: 1
              }))
        ]),
        _: 1
      }, 8, ["action", "on-success", "before-upload"])
    ]),
    (_ctx.tipText)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.tipText), 1))
      : _createCommentVNode("", true)
  ]))
}